import { breakpoints, pxToRem, colors, fonts, pxToCssFont } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Header = styled.header<{ bg?: string; compact?: boolean }>`
  background-color: ${(p) => p.bg ?? colors.$ffffff};
  height: ${pxToRem(80)};
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  padding: ${(p) => (p.compact ? pxToRem(28, 16, 8) : pxToRem(36, 8, 16))};
  z-index: 2;

  @media (min-width: ${breakpoints.tablet}) {
    padding: ${(p) => (p.compact ? pxToRem(18, 19) : pxToRem(36, 12, 16))};
  }
`;

export const Nav = styled.nav`
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  @media (min-width: ${breakpoints.desktop}) {
    max-width: ${pxToRem(1140)};
  }
`;

export const Title = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 28)};
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 28)};
  }
`;

